import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// PWA Service Worker Registration
serviceWorkerRegistration.register({
  onSuccess: () => {
    console.log('PWA: Uygulama cevrimdisi kullanima hazir');
  },
  onUpdate: () => {
    console.log('PWA: Yeni versiyon mevcut, sayfa yenilendiğinde güncellenecek');
  }
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
